/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import UserService from '../../services/UserService';
import UserTypes from '../types/UserTypes';

//* get all department list items
function getAll(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: UserTypes.GET_USER_LIST_REQUEST });
    try {
      const res = await UserService.getAll(pageOption, sortData, keyword);
      dispatch({
        type: UserTypes.GET_USER_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UserTypes.GET_USER_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

const updateQueryParams = (paging, sorting, keyword) => ({
  type: UserTypes.UPDATE_USER_QUERY_PARAMS,
  payload: { paging, sorting, keyword }
});

function add(postData, setErrors, submitting, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: UserTypes.ADD_USER_REQUEST });
    try {
      const res = await UserService.add(postData);
      dispatch({ type: UserTypes.ADD_USER_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().user.queryParams;
      setTimeout(() => dispatch(UserAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      closeModal();
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: UserTypes.ADD_USER_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: UserTypes.GET_USER_ITEM_REQUEST });
    try {
      const res = await UserService.getItem(code);
      dispatch({
        type: UserTypes.GET_USER_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UserTypes.GET_USER_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function update(code, postData, setErrors, submitting, navigate) {
  return async (dispatch, getState) => {
    dispatch({ type: UserTypes.UPDATE_USER_REQUEST });
    try {
      const res = await UserService.update(code, postData);
      dispatch({
        type: UserTypes.UPDATE_USER_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().user.queryParams;
      setTimeout(() => dispatch(UserAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      navigate('/');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: UserTypes.UPDATE_USER_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteItem(code, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: UserTypes.DELETE_USER_REQUEST });
    try {
      const res = await UserService.deleteItem(code);
      dispatch({
        type: UserTypes.DELETE_USER_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().user.queryParams;
      setTimeout(() => dispatch(UserAction.getAll(paginationData, sortingData, keyword)), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UserTypes.DELETE_USER_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getActiveItem() {
  return async (dispatch) => {
    dispatch({ type: UserTypes.GET_USER_ACTIVE_REQUEST });
    try {
      const res = await UserService.getActiveItem();
      dispatch({
        type: UserTypes.GET_USER_ACTIVE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UserTypes.GET_USER_ACTIVE_ERROR,
          error: error.response
        });
      }
    }
  };
}

function resendActivation(code) {
  return async (dispatch) => {
    dispatch({ type: UserTypes.RESEND_ACTIVATION_USER_REQUEST });
    try {
      const res = await UserService.resendActivation(code);
      dispatch({
        type: UserTypes.RESEND_ACTIVATION_USER_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UserTypes.RESEND_ACTIVATION_USER_ERROR,
          error: error.response
        });
      }
    }
  };
}
const UserAction = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem,
  resendActivation,
  updateQueryParams
};

export default UserAction;
